/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import routes from "routes";

const Sidebar = (props: { open: boolean; onClose: () => void }) => {
  const { open, onClose } = props;
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full w-[300px] flex-col border-r border-gray-200 bg-white pb-10 shadow-2xl transition-all dark:border-[#ffffff33] dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 xl:shadow-none ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={() => onClose()}
      >
        <HiX />
      </span>

      <div className={`mx-8 mt-[39.5px] flex items-center`}>
        <div className="font-poppins text-[20px] font-bold uppercase text-biafit-text dark:text-white">
          BiaFit{" "}
          <span className="font-medium text-biafit-primary">Dashboard</span>
        </div>
      </div>
      <div className="mb-7 mt-[39.5px] h-px" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes} onNavigate={onClose} />
      </ul>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
